import React from 'react'

function Caducado() {
    let conf = window.localStorage.getItem('ConfiguracionGeneral')
    conf = JSON.parse(conf)
    return (
        <div className='Caducado'>
            <div className='Logocaducado'></div>
            <div className='mensaje'>
                El enlace ha caducado por favor pogase en contacto con el numero {<a href={`https://wa.me/${conf.ref}`} >+{conf.ref}</a>}
            </div>
        </div>
    )
}

export default Caducado
